/**
 * Navegación pública hacia la página de login.
 *
 * Cuando es `false` (por defecto): no se muestran botones/enlaces tipo
 * "Iniciar sesión", "Ya tengo cuenta" ni "Entrar" que lleven a `/login`.
 *
 * La ruta `/login` sigue activa en el router: administradores y quienes
 * conozcan la URL acceden directamente, p. ej.:
 *   - http://localhost:5173/login
 *   - https://kawescar.cl/login
 *
 * Para mostrar de nuevo esos enlaces en desarrollo o staging, define en `.env`:
 *   VITE_SHOW_PUBLIC_LOGIN_NAV=true
 */
export const SHOW_PUBLIC_LOGIN_NAV =
  import.meta.env.VITE_SHOW_PUBLIC_LOGIN_NAV === 'true';
